import '../styles/rules.css';
import { useTranslation } from '../hooks/useTranslation';
import SEO from '../components/SEO';

const Refund = () => {
  const { t } = useTranslation();

  const createMarkup = (htmlString) => {
    return { __html: htmlString };
  };

  return (
    <div>
      <SEO
        title="Политика возврата — Diamond VPN"
        description="Политика возврата Diamond VPN: условия возврата средств, сроки и порядок обращения в поддержку."
        ogImage="https://diamondvpn.online/preview.jpg"
      />
      <div className="rules-content">
        <div className="rules-container">
          <h1>{t('refund.title')}</h1>

          <p>{t('refund.content.intro')}</p>

          <h2>{t('refund.sections.guarantee')}</h2>
          <p dangerouslySetInnerHTML={createMarkup(t('refund.content.guarantee.description'))} />
          <ul className="ul-items">
            {t('refund.content.guarantee.items').map((item, index) => (
              <li key={index} dangerouslySetInnerHTML={createMarkup(item)} />
            ))}
          </ul>

          <h2>{t('refund.sections.procedure')}</h2>
          <ol>
            {t('refund.content.procedure.items').map((item, index) => {
              if (index === 1) {
                return (
                  <li key={index}>
                    {item}
                    <ul className="ul-items">
                      {t('refund.content.procedure.procedureSubItems').map((subItem, subIndex) => (
                        <li key={subIndex}>{subItem}</li>
                      ))}
                    </ul>
                  </li>
                );
              }
              return <li key={index} dangerouslySetInnerHTML={createMarkup(item)} />;
            })}
          </ol>

          <h2>{t('refund.sections.timing')}</h2>
          <p>{t('refund.content.timing.description')}</p>
          <ul className="ul-items">
            {t('refund.content.timing.items').map((item, index) => (
              <li key={index} dangerouslySetInnerHTML={createMarkup(item)} />
            ))}
          </ul>

          <h2>{t('refund.sections.contacts')}</h2>
          <p>{t('refund.content.contacts.description')}</p>
          <p dangerouslySetInnerHTML={createMarkup(t('refund.content.contacts.email'))} />
          
        </div>
      </div>
    </div>
  );
};

export default Refund;
